import React, { useContext, useState,useEffect } from 'react'
import '../Login/Login.css'
import { useNavigate, NavLink } from 'react-router-dom'
import { User } from "../App"
import { Passaggio } from "../App"
import jwt_decode from "jwt-decode";
import { GoogleLogin, googleLogout } from '@react-oauth/google';


const Login = () => {
  const [showClassPopup, setShowClassPopup] = useState(false);
  const [classe, setClasse] = useState([]);
  const [classeSelezionata, setClasseSelezionata] = useState("");
  const navigate = useNavigate();
  const { user, setuser } = useContext(User);
  const { url } = useContext(Passaggio);
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const userName = sessionStorage.getItem("userName");

    if (token && userName && (!user || Object.keys(user).length === 0)) {
      setuser({ name: userName }); // ripristina l’utente loggato
    }
  }, []);
  const onSuccess = (credentialResponse) => {
    const userObject = jwt_decode(credentialResponse.credential);
    sessionStorage.setItem("token", credentialResponse.credential);
    sessionStorage.setItem("userName", userObject.name);
    setuser(userObject);
    fetch(url + "/popup?email=" + userObject.email + "&" + "user=" + userObject.name, {
      method: 'GET',
    })
      .then(response => response.json())
      .then((dati) => {
        if (dati.risposta == true) {
          setClasse(dati.classi)
          setShowClassPopup(true);
        }
      })
  };

  const onError = () => {
    alert("Login fallito. Riprova.");
  };

  const handleLogout = () => {
    googleLogout(); // opzionale per disconnettere One Tap
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userName");
    setuser({}); // resetta stato
  };
  const Contatti = () => {
    navigate("/contattami")
  }
  const salvaClasse = () => {
    if (classeSelezionata === "") return;

    fetch(url + "/aggiornaclasse", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + sessionStorage.getItem("token")
      },
      body: JSON.stringify({ classe: classeSelezionata })
    })
      .then(response => response.json())
      .then((dati) => {
        if (dati == true) {
          setShowClassPopup(false);
        }
      })

  };
  return (
    //Inizio login
    <div id='contLogin'>
      {/* Introduzione*/}
      <div className='log'>
        <div className="mainContainer">
          <div id='contLogin'>
            <div className='log'>
              <div className='contenitoreLogin'>
                <form>
                  <div className="headingsContainer">
                    <h1 className="mangiuma-elegant">MANGIUMA!</h1>
                    <h2 className='color'>Il tuo pranzo in un CLICK!</h2>
                  </div>
                  <div className="mainContainer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                    {/* Bottone Google OAuth */}
                    {!user || Object.keys(user).length === 0 ? (
                      <GoogleLogin onSuccess={onSuccess} onError={onError} />
                    ) : (
                      <div className='welcomeContainer'>
                        <p style={{ paddingBottom: "10px" }}>Benvenuto, <strong>{user.name}</strong>!</p>
                        <button type="button" onClick={handleLogout}>Logout</button>
                        <br /><br />
                        <button type="button" onClick={() => navigate("/citta")}>Scegli la Citta</button>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <p className="register">Password dimenticata? <a className={"contatto"} onClick={Contatti}>Contattami!</a></p>
        </div>
      </div>
      {showClassPopup && (
        <div className="popupOverlay">
          <div className="popupClasse">
            <h3>Seleziona la tua classe</h3>
            <br />
            <span style={{ fontSize: "12px", fontStyle: "italic" }}>La classe selezionata verrà salvata in via definitiva.</span>

            <select
              onChange={(e) => setClasseSelezionata(e.target.value)}
            >
              <option value="">Scegli...</option>
              {classe.map((elemento) => <option>{elemento.classe}</option>)}
            </select>

            <button onClick={salvaClasse}>
              Conferma
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Login


